<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Ball Park</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h2 class="chapter-number1">A Special Joy</h2>
<p class="chapter-subtitle"><em>(The mysterious dark patch)</em></p>
<p class="flush-left-opener"><span class="big">G</span>etting inside had been routine. The stress came in getting out.</p>
<p class="indented">She had a near-encounter with a nude man who carried a pistol. Hiding from him was like having her nerve endings scraped raw by a hand file.</p>
<p class="indented">Nerves were nine-tenths the battle. Hers were shot for the night.</p>
<p class="indented">She had to remain dead silent. The woman in the house could return at any second. Quinn crept halfway up the staircase toward the lady’s bedroom then slipped out the open side window. The one she’d entered. Propped her bag on the ledge and lowered herself down from the sill. Then she clutched her bag of loot in one hand and held on with the other. Dangled off the side of the house in the moonlight. Fingers slipping. She looked down to locate her landing in the dark before shoving herself outward and dropping from a height above ten feet.</p>
<p class="indented">Quinn remembered to flex when she hit the ground. She’d trained herself well. She toppled over – <em>Nerves! </em>– yet landed quietly on the grass.</p>
<p class="indented">Checked herself out. She wasn’t hurt<em>.</em></p>
<p class="indented">Whenever a plan worked, a special joy thrummed inside her.</p>
<p class="indented">The young woman spotted her boyfriend’s car. Her accomplice. <em>Excellent</em>. She walked a little faster than usual despite an effort to keep her pace casual. <em>God! That guy had a gun!</em> <em>He was starkers!</em> She had a story to tell. <em>Deets, you won’t believe it!</em> In a nick, Quinn slid onto the front passenger seat. Slammed the door shut.</p>
<p class="indented">‘OK, Trucker boy, let’s fly!’</p>
<p class="indented">Deets failed to start up on her command. She looked at him. Suddenly her nerves, those nerves, flared across her chest and snared her throat in a vise. Deets didn’t budge. In the light of a streetlamp a mysterious dark patch across his chest pooled below his belly and fell off his right hip.</p>
<p class="indented">That was blood. All over him. Blood.</p>
<p class="indented">She caught on. She got this.</p>
<p class="indented">Deets was dead.</p>
<p class="indented">He was sitting there dead. He was crazy dead.</p>
<p class="indented"><em>Deets.</em></p>
<p class="indented">Her getaway driver would not be getting away.</p>
<p class="indented">Or getting her away. Not from this.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter001.vue?0980e8c6